export var genericServerErrorStore = {
  state: {
    isThereAGenericServerError: false,
    setGlobalError: function setGlobalError(genericErrorState) {
      this.isThereAGenericServerError = genericErrorState;
    }
  }
};


// WEBPACK FOOTER //
// ./src/service/GenericServerErrorStore.js